export function throwIfFalsy(retVal: string | undefined, key: string) {
  if (!retVal) {
    throw new Error(`Missing environment variable '${key}'`);
  }
  return retVal;
}
